import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import InputSettingsField from './InputSettingsField';
import { StyledAddonAfter } from './SettingsCommonElements';
import PopoverColorPicker from '../../misc/PopoverColorPicker';
import ThemeContext from '../../../theme/ThemeContext';

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const StyledIcon = styled.div`
  transition: all 0.15s ease-in-out;
  border-radius: ${(props) => props.theme.borderRadius}px;
  border: 2px solid ${(props) => props.theme.borderColor};
  width: 17px;
  height: 17px;
  background-color: ${(props) => props.$background};

  &:hover {
    cursor: pointer;
    border-color: ${(props) => props.theme.primaryColor};
    opacity: 0.9;
  }

  svg {
    font-size: 20px;
  }
`;

const ColorPickerSettings = ({
  onChange,
  value,
  addonAfter
}) => {

  const theme = useContext(ThemeContext);

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const addonBeforeNode = (
    <StyledWrapper>
      <StyledIcon tabIndex={-1} theme={theme} $background={!value || value === 'transparent' ? theme.secondaryColor : value} onClick={toggle} />
    </StyledWrapper>
  );

  return (
    <PopoverColorPicker
      isOpen={isOpen}
      value={value}
      onChange={onChange}
      onClickOutside={toggle}
    >
      <div>
        <InputSettingsField
          value={!value || value === 'transparent' ? '' : value}
          addonBefore={addonBeforeNode}
          addonAfter={(<StyledAddonAfter>{addonAfter}</StyledAddonAfter>)}
          onFocus={toggle}
          onClear={() => {
            if (onChange) onChange('');
          }}
        />
      </div>
    </PopoverColorPicker>
  );

};

ColorPickerSettings.propTypes = {
  value: PropTypes.string, //Hex String
  addonAfter: PropTypes.any,
  onChange: PropTypes.func,
};

export default React.memo(ColorPickerSettings);
